/* eslint-disable arrow-body-style */

import _ from 'underscore';

export const getCallToActionStyles = ({ styleOverrides }) => (e, { palette = {} }) => {
  return {
    actionButton: _.extend({
      color: palette.white,
      border: 'none',
      opacity: '90%',
      position: 'absolute',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: 32,
      backgroundColor: '#a19f9d',
    }, styleOverrides.actionButton),
    dismissButton: _.extend({
    }, styleOverrides.dismissButton),
  };
};
